import { t } from 'utils';

const classes = {
  _validation: {
    title: {
      presence: {
        message: () => t.staticAsString('shared.errors.presence'),
        allowEmpty: false,
      },
      length: {
        minimum: 1,
        maximum: 50,
      },
    },
  },
};

export { classes };
